import { BrokerCookie } from "@/api/model"

export type BrokerCookieNameValue = NonNullable<BrokerCookie>["name"]

export const BrokerCookieName = {
  voucher: "voucher",
  conectia_reference: "conectia_reference",
  elmo_customer: "elmo_customer",
  energy_linx: "energy_linx",
  money_super_market: "money_super_market",
  google: "google",
  meta: "meta",
} as const satisfies Record<BrokerCookieNameValue, BrokerCookieNameValue>

export const PROMOTIONAL_CODE_USED_COOKIE = "promotional_code_used"

export const JUST_MOVE_IN_COOKIE_VALUE = "JUSTMOVEIN"

export const QueryBrokerName = {
  CONECTIA: "conectia",
  ELMO: "elmo",
  ENERGY_LINX: "energy_linx",
  JUST_MOVE_IN: "just_move_in",
  MONEY_SUPER_MARKET: "money_super_market",
} as const

/** Maps query param `name` value to the cookie that should be set */
export const BROKER_NAME_TO_COOKIE: Record<string, string> = {
  [QueryBrokerName.CONECTIA]: BrokerCookieName.conectia_reference,
  [QueryBrokerName.ELMO]: BrokerCookieName.elmo_customer,
  [QueryBrokerName.JUST_MOVE_IN]: BrokerCookieName.voucher,
  [QueryBrokerName.ENERGY_LINX]: BrokerCookieName.energy_linx,
  [QueryBrokerName.MONEY_SUPER_MARKET]: BrokerCookieName.money_super_market,
}

/** Cookie expiry: 1 hour for short-lived brokers, 30 days for the rest */
export const SHORT_EXPIRY_BROKERS: Set<string> = new Set([
  QueryBrokerName.ELMO,
  QueryBrokerName.JUST_MOVE_IN,
])
